module.exports = __webpack_public_path__ + "img/erweicode.0f09e19c.jpg";